import React, { useState, useEffect } from 'react';
import ExamSidebar from './ExamSidebar';
import ExamContent from './ExamContent';
import { t } from 'i18next';

export function CreateExam(props) {
  const { step } = props;

  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      id: 0,
      route: 'curso',
      text: t('exams.stepsTextExamsCourse')
    },
    {
      id: 1,
      route: 'nome',
      text: t('exams.stepsTextExamsName')
    },
    {
      id: 2,
      route: 'duracao',
      text: t('exams.stepsTextExamsDuration')
    }
  ];

  function getStep() {
    switch (step) {
      case 'curso':
        setCurrentStep(0);
        break;
      case 'nome':
        setCurrentStep(1);
        break;
      case 'duracao':
        setCurrentStep(2);
        break;
      default:
        setCurrentStep(0);
        break;
    }
  }

  useEffect(() => getStep());

  return (
    <div className="main-screen">
      <ExamSidebar
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        steps={steps}
      />

      <div className="main-content">
        <ExamContent
          step={step}
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      </div>
    </div>
  );
}
